import {Icon} from '@rsuite/icons'
import {icons} from '../../../icons'

/**
 * Icon to mark the AI-generated content.
 * @returns the React element.
 */
export const AiIcon = () => <Icon fontSize={16} as={icons.Sparks} color={'var(--rs-text-secondary)'}/>
